module.exports = __webpack_public_path__ + "static/media/MuhammadTanveerTanoli(F)(S).3f65e071.JPG";